<!-- Carriers Tab Content -->
<div class="carriers-tab-content">
  <!-- Section Header -->
  <div class="section-header mb-4">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h6 class="mb-1">
          <i class="bi bi-truck text-primary me-2"></i>Carrier Management
        </h6>
        <p class="text-muted small mb-0">Manage carriers and their charges</p>
      </div>
      <button class="btn btn-primary" (click)="openAddCarrierModal()">
        <i class="bi bi-plus-circle me-1"></i>Add Carrier
      </button>
    </div>
  </div>

  <!-- Search Bar -->
  <div class="row mb-3">
    <div class="col-12">
      <input
        type="text"
        class="form-control"
        placeholder="Search carriers by code, name, mode, or region..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="filterCarriers()"
      />
    </div>
  </div>

  <!-- Carriers Table -->
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>Modes</th>
          <th>Regions</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let carrier of filteredCarriers">
          <td><strong>{{ carrier.code }}</strong></td>
          <td>{{ carrier.name }}</td>
          <td>
            <span *ngIf="!carrier.modes || carrier.modes.length === 0">-</span>
            <span *ngIf="carrier.modes && carrier.modes.length > 0">{{ carrier.modes.join(', ') }}</span>
          </td>
          <td>
            <span *ngIf="!carrier.regions || carrier.regions.length === 0">-</span>
            <span *ngIf="carrier.regions && carrier.regions.length > 0">{{ carrier.regions.join(', ') }}</span>
          </td>
          <td>{{ formatDate(carrier.createdAt) }}</td>
          <td>
            <span class="badge bg-primary" *ngIf="carrier.isActive">Active</span>
            <span class="badge bg-secondary" *ngIf="!carrier.isActive">Inactive</span>
          </td>
          <td>
            <button class="btn btn-sm btn-link p-1" (click)="openCarrierChargesModal(carrier); $event.stopPropagation()" title="Manage Charges">
              <i class="bi bi-currency-dollar"></i>
            </button>
            <button class="btn btn-sm btn-link p-1" (click)="openEditCarrierModal(carrier)" title="Edit">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-link text-danger p-1" (click)="deleteCarrier(carrier.id)" title="Delete">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="filteredCarriers.length === 0">
          <td colspan="7" class="text-center text-muted py-4">
            <i class="bi bi-inbox me-2"></i>No carriers found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Create Carrier Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeAddCarrierModal()"></div>
<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Add Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Create Carrier</h5>
        <button type="button" class="btn-close" (click)="closeAddCarrierModal()"></button>
      </div>

      <!-- Add Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Two Column Layout for Name and Code -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="addName" class="form-label">Carrier Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="addName"
                [(ngModel)]="formData.name"
                name="name"
                placeholder="e.g. Maersk"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="addCode" class="form-label">Code <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="addCode"
                [(ngModel)]="formData.code"
                name="code"
                placeholder="e.g. MAERSK"
                required
              />
            </div>
          </div>

          <!-- Shipment Modes -->
          <div class="mb-3">
            <label class="form-label">Shipment Modes <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2">
              <button
                type="button"
                *ngFor="let mode of availableModes"
                class="btn btn-outline-primary mode-pill"
                [class.active]="isModeSelected(mode)"
                (click)="toggleMode(mode)">
                {{ mode }}
              </button>
            </div>
          </div>

          <!-- Regions Served -->
          <div class="mb-3">
            <label class="form-label">Regions Served (Optional)</label>
            <div class="d-flex flex-wrap gap-2 mb-2">
              <button
                type="button"
                *ngFor="let region of availableRegions"
                class="btn btn-outline-secondary region-pill"
                [class.active]="isRegionSelected(region)"
                (click)="toggleRegion(region)">
                {{ region }}
              </button>
            </div>

            <!-- Custom Region Input -->
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Add custom region"
                [(ngModel)]="customRegionInput"
                name="customRegion"
                (keyup.enter)="addCustomRegion()"
              />
              <button class="btn btn-outline-secondary" type="button" (click)="addCustomRegion()">
                Add
              </button>
            </div>

            <!-- Display Selected Custom Regions -->
            <div class="mt-2" *ngIf="formData.regions && formData.regions.length > 0">
              <span class="badge bg-secondary me-1" *ngFor="let region of formData.regions">
                {{ region }}
                <i class="bi bi-x-circle ms-1" style="cursor: pointer;" (click)="toggleRegion(region)"></i>
              </span>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label for="addNotes" class="form-label">Notes (Optional)</label>
            <textarea
              class="form-control"
              id="addNotes"
              [(ngModel)]="formData.notes"
              name="notes"
              rows="3"
              placeholder="Additional notes about this carrier"></textarea>
          </div>

          <!-- Status Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="addStatus"
                [(ngModel)]="formData.isActive"
                name="isActive"
              />
              <label class="form-check-label" for="addStatus">
                Enable this carrier for use in the system
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Add Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddCarrierModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createCarrier()">Create Carrier</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Carrier Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeEditCarrierModal()"></div>
<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Edit Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Carrier</h5>
        <button type="button" class="btn-close" (click)="closeEditCarrierModal()"></button>
      </div>

      <!-- Edit Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Two Column Layout for Name and Code -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="editName" class="form-label">Carrier Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="editName"
                [(ngModel)]="editFormData.name"
                name="editName"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="editCode" class="form-label">Code <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="editCode"
                [(ngModel)]="editFormData.code"
                name="editCode"
                required
              />
            </div>
          </div>

          <!-- Shipment Modes -->
          <div class="mb-3">
            <label class="form-label">Shipment Modes <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2">
              <button
                type="button"
                *ngFor="let mode of availableModes"
                class="btn btn-outline-primary mode-pill"
                [class.active]="isModeSelected(mode, true)"
                (click)="toggleMode(mode, true)">
                {{ mode }}
              </button>
            </div>
          </div>

          <!-- Regions Served -->
          <div class="mb-3">
            <label class="form-label">Regions Served (Optional)</label>
            <div class="d-flex flex-wrap gap-2 mb-2">
              <button
                type="button"
                *ngFor="let region of availableRegions"
                class="btn btn-outline-secondary region-pill"
                [class.active]="isRegionSelected(region, true)"
                (click)="toggleRegion(region, true)">
                {{ region }}
              </button>
            </div>

            <!-- Custom Region Input -->
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Add custom region"
                [(ngModel)]="customRegionInput"
                name="customRegionEdit"
                (keyup.enter)="addCustomRegion(true)"
              />
              <button class="btn btn-outline-secondary" type="button" (click)="addCustomRegion(true)">
                Add
              </button>
            </div>

            <!-- Display Selected Custom Regions -->
            <div class="mt-2" *ngIf="editFormData.regions && editFormData.regions.length > 0">
              <span class="badge bg-secondary me-1" *ngFor="let region of editFormData.regions">
                {{ region }}
                <i class="bi bi-x-circle ms-1" style="cursor: pointer;" (click)="toggleRegion(region, true)"></i>
              </span>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label for="editNotes" class="form-label">Notes (Optional)</label>
            <textarea
              class="form-control"
              id="editNotes"
              [(ngModel)]="editFormData.notes"
              name="editNotes"
              rows="3"
              placeholder="Additional notes about this carrier"></textarea>
          </div>

          <!-- Status Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="editStatus"
                [(ngModel)]="editFormData.isActive"
                name="editIsActive"
              />
              <label class="form-check-label" for="editStatus">
                Enable this carrier for use in the system
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Edit Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditCarrierModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateCarrier()">Save Changes</button>
      </div>
    </div>
  </div>
</div>

<!-- Carrier-Specific Charges Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showCarrierChargesModal"
     style="z-index: 1070 !important; background-color: rgba(0, 0, 0, 0.7) !important;"
     (click)="closeCarrierChargesModal()"></div>
<div class="modal fade show d-block" *ngIf="showCarrierChargesModal"
     style="z-index: 1071 !important; position: fixed !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Header with Icon and Title -->
      <div class="modal-header border-0 pb-0">
        <div class="d-flex align-items-center gap-3">
          <div class="icon-wrapper" style="background-color: #e7f3ff; padding: 12px; border-radius: 12px;">
            <i class="bi bi-truck" style="font-size: 1.5rem; color: #0d6efd;"></i>
          </div>
          <div>
            <h5 class="modal-title mb-0">Carrier-Specific Charges</h5>
            <p class="text-muted small mb-0" *ngIf="selectedCarrierForCharges">
              {{ selectedCarrierForCharges.name }} • Shanghai Port
            </p>
          </div>
        </div>
        <button type="button" class="btn-close" (click)="closeCarrierChargesModal()"></button>
      </div>

      <!-- Info Box -->
      <div class="modal-body pt-3">
        <div class="alert alert-info d-flex align-items-start" role="alert" style="background-color: #e7f3ff; border-color: #b6d4fe;">
          <i class="bi bi-info-circle me-2 mt-1"></i>
          <div>
            Configure carrier-specific charges for FCL shipments. Only charges with amounts greater than 0 will be saved.
          </div>
        </div>

        <!-- Select Carriers Section -->
        <div class="card border-0 shadow-sm mb-3">
          <div class="card-body">
            <h6 class="card-title mb-3">
              <i class="bi bi-plus-circle me-2"></i>Select Carriers
            </h6>

            <!-- Add Carrier Dropdown -->
            <div class="mb-3">
              <select class="form-select" [(ngModel)]="selectedCarrierToAdd" (change)="addCarrierToSelection()">
                <option value="">+ Add Carrier</option>
                <option *ngFor="let carrier of availableCarriersForSelection" [value]="carrier.id">
                  {{ carrier.name }}
                </option>
              </select>
            </div>

            <!-- Selected Carriers List or Empty State -->
            <div *ngIf="selectedCarriersForCharges.length === 0" class="text-center py-5">
              <i class="bi bi-truck" style="font-size: 3rem; color: #dee2e6;"></i>
              <p class="text-muted mt-3 mb-1"><strong>No Carriers Selected</strong></p>
              <p class="text-muted small">Choose one or more carriers to configure their specific charges for this route.</p>
            </div>

            <!-- Selected Carriers Table -->
            <div *ngIf="selectedCarriersForCharges.length > 0" class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Carrier</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let carrier of selectedCarriersForCharges">
                    <td>
                      <i class="bi bi-truck me-2"></i>{{ carrier.name }}
                    </td>
                    <td class="text-end">
                      <button class="btn btn-sm btn-link text-danger p-0" (click)="removeCarrierFromSelection(carrier.id)">
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCarrierChargesModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCarrierCharges()">
          Save Carrier Charges
        </button>
      </div>
    </div>
  </div>
</div>
